// extracted by mini-css-extract-plugin
export default {"button":"_5a6vC","readMore":"crLcU","container":"uS9DA","mobile-container":"KeK6s","mobileContainer":"KeK6s","wrapper":"IxZIo","readMoreExtraMargin":"VtE4V","marginBottom":"BBYjO"};